import { useSelector } from "react-redux";
import { Constant } from "../../constants/constant";
import { commonReducerSelector } from "../../redux/selector";
import { isEmpty } from "lodash";

export function propsToInitialState(data) {
  const dataInit = { ...data };

  let danhSachToaDo = [];
  const arrayReplacemo = data?.viTriDiaLy?.danhSachToaDo?.replaceAll("[", "");
  const arrayReplacedong = arrayReplacemo?.replaceAll("]", "");
  const arraysplit = arrayReplacedong?.split(",");
  arraysplit?.forEach(item => {
    const itemArraySplit = item?.split(":");
    danhSachToaDo.push({
      x: Number(itemArraySplit?.[0]) || null,
      y: Number(itemArraySplit?.[1]) || null
    });
  });
  // let kieuToaDo = null;
  // if (danhSachToaDo?.length > 1) {
  //   kieuToaDo = { tenMuc: "Tọa độ vùng" };
  // }

  dataInit.dienTich = data?.dienTich || null;
  dataInit.phuongXa = data?.donViHanhChinh_Xa || null;
  dataInit.quanHuyen = data?.donViHanhChinh_Huyen || null;
  dataInit.tinhThanh = data?.donViHanhChinh_Tinh || Constant.TINHTHANH;
  dataInit.viTriDiaLy = {
    // kieuToaDo: kieuToaDo || { tenMuc: "Tọa độ điểm" },
    danhSachToaDo: !isEmpty(danhSachToaDo)
      ? danhSachToaDo
      : [{ x: null, y: null }],
    toaDoX: data?.viTriDiaLy?.toaDoX || null,
    toaDoY: data?.viTriDiaLy?.toaDoY || null,
    kinhTuyenTruc: "4326"
    // muiChieu: data?.viTriDiaLy?.muiChieu || 3
  };

  return dataInit;
}

export function parseDataSave(value, profile) {
  const dataSave = { ...value };

  let viTriDiaLy = {};
  viTriDiaLy.danhSachToaDo = value?.viTriDiaLy?.danhSachToaDo || [];
  let arrayStringToaDo = [];
  viTriDiaLy.danhSachToaDo.forEach(item => {
    if (item?.x || item?.y) {
      arrayStringToaDo.push(
        `[${item?.x ? item?.x : ""}:${item?.y ? item?.y : ""}]`
      );
    }
  });
  viTriDiaLy.danhSachToaDo = arrayStringToaDo?.join() || null;
  // viTriDiaLy.kinhTuyenTruc = value?.viTriDiaLy?.kinhTuyenTruc?.maMuc;
  viTriDiaLy.kinhTuyenTruc = "4326";
  // viTriDiaLy.muiChieu = value?.viTriDiaLy?.muiChieu || 0;

  dataSave.dienTich = value?.dienTich || 0;
  dataSave.idDoanhNghiep = profile?.idDoanhNghiep || 0;
  dataSave.maTinh = value?.tinhThanh?.maTinh || null;
  dataSave.donViHanhChinh_Tinh = value?.tinhThanh || null;
  dataSave.maHuyen = value?.quanHuyen?.maHuyen || null;
  dataSave.donViHanhChinh_Huyen = value?.quanHuyen || null;
  dataSave.maXa = value?.phuongXa?.maXa || null;
  dataSave.donViHanhChinh_Xa = value?.phuongXa || null;
  dataSave.viTriDiaLy = viTriDiaLy || null;

  return dataSave;
}

export const handleDataBaseSpatial = dataViTri => {
  let danhSachToaDo = [];
  const arrayReplacemo = dataViTri?.danhSachToaDo?.replaceAll("[", "");
  const arrayReplacedong = arrayReplacemo?.replaceAll("]", "");
  const arraysplit = arrayReplacedong?.split(",");
  arraysplit?.forEach(item => {
    const itemArraySplit = item?.split(":");
    danhSachToaDo.push({
      x: Number(itemArraySplit?.[0]) || null,
      y: Number(itemArraySplit?.[1]) || null
    });
    // danhSachToaDo.push({
    //     x: Number(itemArraySplit?.[1]) || null,
    //     y: Number(itemArraySplit?.[0]) || null,
    // });
  });
  // Kieu du lieu do hoa: 1:point, 2 line, 3 polygon
  let typegeom = 0;
  if (danhSachToaDo?.length === 1) {
    typegeom = 1;
  } else if (danhSachToaDo?.length === 2) {
    typegeom = 2;
  } else if (danhSachToaDo?.length > 2) {
    typegeom = 3;
  }

  /// Dữ liệu không gian của đối tượng (Trường hợp không phải kiểu point -> phải nhập theo geojson) - Dạng ASTEXT trong postgis
  let geoastext = null;
  let arrayStringToaDo = [];
  if (danhSachToaDo?.length === 2) {
    danhSachToaDo.forEach(item => {
      arrayStringToaDo.push(`${item?.y} ${item?.x}`);
    });
    geoastext = `LINESTRING(${arrayStringToaDo?.join(", ")})`;
  } else if (danhSachToaDo?.length > 2) {
    danhSachToaDo.forEach(item => {
      arrayStringToaDo.push(`${item?.y} ${item?.x}`);
    });
    geoastext = `POLYGON((${arrayStringToaDo?.join(", ")}))`;
  }

  const dataBaseSpatial = {
    typegeom: typegeom,
    arrpoint: danhSachToaDo || null,
    ktt: dataViTri?.kinhTuyenTruc || null,
    // muichieu: dataViTri?.muiChieu || 0,
    // geoastext: geoastext,
    madinhdanh: dataViTri?.maDinhDanh || null,
    id: dataViTri?.id || 0,
    matinh: dataViTri?.maTinhThanh || null,
    tinhThanh: dataViTri?.tinhThanh || null,
    mahuyen: dataViTri?.maQuanHuyen || null,
    quanHuyen: dataViTri?.quanHuyen || null,
    maxa: dataViTri?.maPhuongXa || null,
    phuongXa: dataViTri?.phuongXa || null,
    diachi: dataViTri?.diaChiChiTiet || null
  };
  return dataBaseSpatial;
};
